module.exports = __webpack_public_path__ + "img/3-large.9c75a36b.jpg";